import axios from 'axios';

import * as utils from '../utils/utils.js';

export const deleteVenue = async (venue_id) => {
    const session_url = utils.backendUrl() + '/venue';

    try {
        const response = await axios.delete(session_url, {
            data: {
                venue_id: venue_id,
            },
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        });
        return response.data.response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
